import { convertToHex, convertToRgb } from '@carboncopyco/utils';

export interface ColorBadgeProps {
  color: string;
  size?: number;
  onClick?: (color?: string) => void;
}

export const ColorBadge = ({ color, size = 16, onClick }: ColorBadgeProps) => (
  <div
    className="relative overflow-hidden border-ds-natural-150 border border-solid box-content rounded-full"
    style={{
      height: size,
      width: size,
    }}
  >
    <TransparentBackground />
    <div
      onClick={() => onClick?.(color)}
      className="cursor-pointer transition-all absolute inset-0 rounded-full flex"
    >
      <FullColorSemicircle
        color={color}
        size={size}
      />
      <TransparentColorSemicircle
        color={color}
        size={size}
      />
    </div>
  </div>
);

const TransparentBackground = () => {
  const transparentBackgroundImage =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAADFJREFUOE9jZGBgEGHAD97gk2YcNYBhmIQBgWSAP52AwoAQwJvQRg1gACckQoC2gQgAIF8IscwEtKYAAAAASUVORK5CYII=';

  return (
    <div
      className="absolute inset-0 rounded-full"
      style={{
        background: `url(${transparentBackgroundImage}) left center`,
        backgroundSize: '6px',
      }}
    />
  );
};

type SemicircleProps = Pick<ColorBadgeProps, 'color'> &
  Required<Pick<ColorBadgeProps, 'size'>>;

const FullColorSemicircle = ({ color, size }: SemicircleProps) => {
  const colorRgb = convertToRgb(color);
  const fullColor = convertToHex({ ...colorRgb, a: 1 });

  return (
    <div
      style={{
        background: fullColor,
        color: fullColor,
        borderRadius: `${size}px 0 0 ${size}px`,
        height: size,
        width: size / 2,
      }}
    />
  );
};

const TransparentColorSemicircle = ({ color, size }: SemicircleProps) => (
  <div
    style={{
      background: color,
      color: color,
      borderRadius: `0 ${size}px ${size}px 0`,
      height: size,
      width: size / 2,
    }}
  />
);
